import { createSlice } from '@reduxjs/toolkit';

import { baseApi } from './base-api';

import { TBaseState } from '../types/common';

const initialState: TBaseState = {
  avalableCurrencies: [],
  userRoles: [],
};

export const baseSlice = createSlice({
  name: 'base',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    build
      .addMatcher(baseApi.endpoints.getCurrencies.matchFulfilled, (state: TBaseState, action) => {
        state.avalableCurrencies = action.payload;
      })
      .addMatcher(baseApi.endpoints.getUserRoles.matchFulfilled, (state: TBaseState, action) => {
        state.userRoles = action.payload;
      })
  },
});
